import React from 'react';
import Carousel from './Carousel';
import BlogSection from '../pages/BlogSection';
import TourPackages from '../pages/TourPackages';
import GallerySection from '../pages/GallerySection';
import FeaturesSection from '../pages/FeaturesSection';
import SpecialOfferSection from '../pages/SpecialOfferSection';
import TopDestinationSection from '../pages/TopDestinationSection';
import TestimonialSection from '../pages/TestimonialSection';
import BlogSectionfoot from '../pages/BlogSectionfoot';


const HeroSection = () => {

  return (


    <div className="th-hero-wrapper hero-1" id="hero">

<Carousel/>
<BlogSection/>
<TourPackages/>
<GallerySection/>
<FeaturesSection/>
{/* <SpecialOfferSection/> */}
<TopDestinationSection/>
<TestimonialSection/>
<BlogSectionfoot/>
    </div>
  );
};

export default HeroSection;
